import { useFormContext } from 'react-hook-form';
import { Alert, FormControlLabel, Grid, Stack, TextField } from '@mui/material';
import { ETLExecutionModeEnum, ScheduleETLJob } from '~/api/types';
import { modalOverflowBoxStyles } from '~/components/styles';
import { getScheduleAlertWording } from '~/utils';
import { MAX_JOB_NAME_LENGTH } from '~/validation/scheduleETLJobSchema';
import { ScheduleExecutionBlock, WorkspaceField, WorkspaceFileField } from '..';
import ExecutionModeField from './ExecutionModeField';

const ScheduleJobForm = () => {
  const {
    watch,
    register,
    formState: { errors },
  } = useFormContext();
  const formValues = watch();

  const alertWording = getScheduleAlertWording(formValues as ScheduleETLJob);

  return (
    <Stack sx={modalOverflowBoxStyles} spacing={2}>
      <Grid container spacing={4}>
        <Grid size={6}>
          <FormControlLabel
            label="JOB NAME"
            required
            control={
              <TextField
                {...register('name')}
                placeholder="Enter job name"
                error={!!errors.name}
                helperText={
                  (errors?.name?.message as string) ||
                  `Use up to ${MAX_JOB_NAME_LENGTH} characters(alphanumeric, hyphens or underscores)`
                }
                slotProps={{ htmlInput: { maxLength: MAX_JOB_NAME_LENGTH } }}
              />
            }
          />
        </Grid>
        <Grid container size={12}>
          <Grid size={6}>
            <WorkspaceField />
          </Grid>
          <Grid size={6}>
            <WorkspaceFileField />
          </Grid>
        </Grid>
        <Grid size={12}>
          <ExecutionModeField />
        </Grid>

        {formValues.execution_mode === ETLExecutionModeEnum.SCHEDULE && <ScheduleExecutionBlock />}
        {!!alertWording && (
          <Grid size={12}>
            <Alert severity="info">{alertWording}</Alert>
          </Grid>
        )}
      </Grid>
    </Stack>
  );
};

export default ScheduleJobForm;
